import i18nRouteMeta from '@/app-core/mixins/i18n/i18nRouteMeta'
import API from '@/app-core/api/Api'
import StoreCommon from '@/app-core/mixins/store/storeCommon'
import Translatable from '@/app-core/mixins/translatable'
import PaymentTypeEnum from '@/app-core/api/enums/PaymentTypeEnum'
import {getContrastColor} from '@/app-core/lib/utils/color'
import OrderCommon from '@/app-core/mixins/order/orderCommon'
import {toLocaleUpperCase} from '@/app-core/lib/helpers'

export default {
  name      : 'AccountOrderHistory',
  components: {},
  directives: {},
  mixins    : [i18nRouteMeta, StoreCommon, OrderCommon, Translatable],
  props     : {},
  enums     : {},
  dataStore : {},
  data() {
    return {
      init        : false,
      loading     : false,
      currentPage : 1,
      itemsPerPage: 5,
      totalItems  : 0,
      items       : []
    }
  },
  computed: {
    PaymentTypeEnum() {
      return PaymentTypeEnum
    }
  },
  watch: {
    currentPage() {
      this.getData()
    }
  },
  beforeCreate() {
  },
  created() {
    this.getData()
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {
    toLocaleUpperCase,
    getContrastColor,

    gotoStatusPage(item) {
      if (this.ordersCompleted(this.getOrderStores(item), 'OrderStatusId')) return

      this.$router.push({name: 'OrderStatus', params: {orderId: item.OrderId}})
    },

    getOrderCode(item) {
      const [oldCode, newCode] = item?.OrderCode?.split('-')
      const code = (newCode || oldCode || '')
      const part1 = code.slice(0, 3)
      const part2 = code.slice(3, 6)
      return `#${part1}-${part2}`
    },

    getOrderStores(order) {
      return order?.Stores?.filter((store) => !store.IsMainStore) || []
    },

    getStoreOrderItemsName(item) {
      const products = []
      const stores = this.getOrderStores(item) || []
      stores.forEach(store => {
        store.Items.forEach(item => {
          item.Items.forEach(product => {
            products.push(this.getTranslatedField(product))
          })
        })
      })
      return products.join(', ')
    },

    getOrderStatusById(statusId) {
      const statuses = this.$te('Cart.OrderStatus') ? this.$t('Cart.OrderStatus') : []
      
      return statuses.find(status => status.Id === statusId) || {}
    },

    getData() {
      this.loading = true

      API.Resource.Account.Orders({
        limit: this.itemsPerPage,
        page : this.currentPage
      })
        .then(response => {
          if (API.isResponseSuccess(response)) {
            const data = API.responseData(response)
            this.totalItems = Math.ceil((data?.count || 0) / this.itemsPerPage)
            this.items = data?.items || []
          }
        })
        .catch(e => {
        })
        .finally(() => {
          this.loading = false
          this.init = true
        })
    }
  }
}
